import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed } from 'vue'
import router from '@/router';
import { config, power } from '@/store';
import Logo from "@/layout/components/logo.vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from 'vue-router';
type routeItem = {
  meta: {
    submenu?: boolean;
    sidebar: boolean;
    icon: string;
    title: string;
  },
  path: string;
  name: string;
  children: routeItem[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'sidebar',
  setup(__props, { expose: __expose }) {
  __expose();

const route = useRoute();
const uRouter = useRouter();
const { t } = useI18n();

const show = ref(true);

const go_home = () => {
  router.push('/');
}

const routes = computed<routeItem[]>(() => {
  return router.options.routes as any;
})

const menuActive = computed(() => {
  switch (route.path) {
    case '/manga-list':
      return '/media-list';
    case '/chapter-list':
      return '/media-list';
    case '/manga-info':
      return '/media-list';
    default:
      return route.path;
  }

})

const userLimit = computed(() => (item: any) => {

  const title = item.meta.title;

  if (title === 'mediaManage' && !power.editMedia) {
    return false;
  }

  if (title === 'account' && !power.editUser) {
    return false;
  }

  return true;

})

onMounted(() => {
  config.sidebarCollapse = false;
})

const __returned__ = { route, uRouter, t, show, go_home, routes, menuActive, userLimit, get config() { return config }, Logo }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})